import * as yup from 'yup';

export function createYupSchema(schema, config) {
  const { id, validationType, validations = [] } = config;
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type] || !params) {
      return;
    }
    validator = validator[type](...params);
  });
  
  // Специальная валидация для contactNumber (мобильного номера)
  // Проверяем длину и формат (только цифры, 7-15 символов)
  if (id === 'contactNumber' && validationType === 'number') {
    validator = validator.test(
      'phone-length',
      'Phone number must be between 7 and 15 digits',
      function(value) {
        if (!value) return true; // required проверяется отдельно
        const phoneDigits = String(value).replace(/\D/g, '');
        return phoneDigits.length >= 7 && phoneDigits.length <= 15;
      }
    ).test(
      'phone-format',
      'Phone number should contain only numeric digits',
      function(value) {
        if (!value) return true;
        const phoneDigits = String(value).replace(/\D/g, '');
        return /^\d+$/.test(phoneDigits);
      }
    );
  }
  
  schema[id] = validator;
  return schema;
}
